// extracted by mini-css-extract-plugin
var _1 = "nUV0b";
export { _1 as "base" }
